import { render } from "./CardResourceCounter.vue?vue&type=template&id=c3ceb762&ts=true"
import script from "./CardResourceCounter.vue?vue&type=script&lang=ts"
export * from "./CardResourceCounter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__